<div class="tw:flex tw:h-full tw:overflow-x-hidden">
  <div
    class="tw:flex tw:flex-col tw:justify-start tw:pb-2"
    [ngClass]="{ 'tw:hidden': !isSidebarOpen() }">
    <p-menu [model]="menuItems()">
      <ng-template
        let-submenu
        pTemplate="submenuheader">
        <div class="tw:flex tw:items-center tw:justify-between tw:gap-2">
          <span>{{ submenu.label }}</span>
          @if (submenu.label === 'General') {
            <i
              class="pi pi-chevron-left tw:cursor-pointer"
              pTooltip="Hide filters"
              (click)="toggleSidebar()"
              test-id="hide-filter-sidebar"></i>
          }
        </div>
      </ng-template>
    </p-menu>
    <p-divider
      layout="horizontal"
      class="tw:mt-1" />
    <ng-container [ngTemplateOutlet]="eventFiltersMenu" />
  </div>
  <p-divider
    layout="vertical"
    class="tw:z-2" />
  <div
    test-id="notification-prevent-default"
    class="tw:flex tw:flex-col col-10 tw:flex-auto"
    (keydown.enter)="$event.preventDefault()">
    <div class="tw:flex tw:justify-between tw:flex-wrap tw:p-2 tw:gap-2">
      <div class="tw:flex tw:items-center tw:gap-3">
        <div
          test-id="notification-menu-popover-show"
          class="tw:flex tw:items-center tw:p-2 tw:justify-between select-popover tw:cursor-pointer tw:border tw:border-surface tw:text-muted-color"
          [class.tw:hidden]="!isMenuPopoverVisible()"
          #generalFiltersMenu
          (mouseenter)="menuPopover.show($event)"
          (click)="menuPopover.show($event)">
          <span [class]="activeMenuItem()?.icon"></span>
          <span class="tw:ms-1">
            {{ activeMenuItem()?.label }}
          </span>
          <p-popover
            #menuPopover
            [style]="{ 'max-height': '50vh', overflow: 'hidden', 'overflow-y': 'auto' }">
            <p-menu [model]="menuItems()" />
            <p-divider
              layout="horizontal"
              class="tw:mt-1" />
            <ng-container [ngTemplateOutlet]="eventFiltersMenu" />
          </p-popover>
        </div>

        <i
          class="pi pi-filter tw:ms-1 tw:cursor-pointer"
          [class.tw:hidden!]="isSidebarOpen() || isMenuPopoverVisible()"
          [pTooltip]="isSidebarOpen() ? 'Close sidebar' : 'Open sidebar'"
          (click)="toggleSidebar()"
          test-id="toggle-sidebar"></i>
        <div class="tw:flex tw:items-center tw:gap-2">
          <p-iconfield
            iconPosition="left"
            class="tw:w-[80vw] tw:sm:w-[30vw] tw:flex-1">
            <p-inputicon class="pi pi-search" />
            <input
              test-id="notification-search-text"
              pInputText
              fluid
              type="search"
              placeholder="Search"
              [formControl]="form.controls.searchText"
              (keydown.enter)="isSearchFieldEnabled() && reloadNotifications()" />
          </p-iconfield>
          @if (isFiltersApplied()) {
            <p-button
              test-id="notification-clear-filters"
              [buttonProps]="{ autofocus: false }"
              (click)="clearFilters()"
              variant="text"
              size="small"
              label="Clear Filters"
              icon="pi pi-times" />
          }
        </div>
      </div>
      <p-multiSelect
        test-id="notification-object-filters"
        placeholder="Object Type"
        optionLabel="name"
        [formControl]="form.controls.objectFilters"
        [options]="objectFilterValues()"
        [showClear]="true"
        (onChange)="reloadNotifications()"
        (onClear)="reloadNotifications()">
        <ng-template
          let-option
          pTemplate="option">
          <div
            class="notification-object-chip"
            [ngStyle]="getObjectTypeStyle(option.key)">
            {{ option.name }}
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
    <div
      class="tw:flex tw:justify-between tw:bg-emphasis tw:border-t tw:border-surface tw:border-b tw:border-surface tw:py-3 tw:px-4">
      <div class="tw:flex tw:items-center tw:gap-3">
        <p-checkbox
          [binary]="true"
          [ngModel]="areAllNotificationsSelected()"
          (ngModelChange)="areAllNotificationsSelected.set($event)"
          (onChange)="onSelectAllChange($event)"
          test-id="select-all"
          inputId="select-all-checkbox"
          [ngModelOptions]="{ standalone: true }" />
        <label
          class="tw:font-normal"
          [ngClass]="{ 'tw:font-semibold': areAllNotificationsSelected() }">
          {{
            areAllNotificationsSelected()
              ? selectedNotificationKeys().length + ' ' + 'selected'
              : 'Select All'
          }}
        </label>
      </div>
      <div class="tw:flex tw:gap-2">
        @if (selectedNotificationKeys().length) {
          <p-button
            test-id="notification-mark-as-read"
            [buttonProps]="{ autofocus: false }"
            (click)="toggleMarkAsRead(true)"
            variant="outlined"
            size="small"
            icon="pi pi-check"
            label="Mark as Read" />
          <p-button
            test-id="notification-mark-as-unread"
            [buttonProps]="{ autofocus: false }"
            (click)="toggleMarkAsRead(false)"
            variant="outlined"
            severity="secondary"
            size="small"
            label="Mark as Unread" />
        }
        <p-button
          test-id="notification-date"
          [buttonProps]="{ autofocus: false }"
          [pTooltip]="
            form.controls.sortByOrder.value === SORT_BY_ORDER.ASC
              ? 'View Newest to Oldest'
              : 'View Oldest to Newest'
          "
          (click)="onDateSortChange()"
          severity="secondary"
          size="small"
          icon="pi pi-sort-alt"
          label="Date" />
      </div>
    </div>
    <dx-data-grid
      [dataSource]="notificationDatasource"
      [columns]="columns()"
      [columnAutoWidth]="true"
      [showBorders]="true"
      [showColumnLines]="false"
      [hoverStateEnabled]="true"
      [showColumnHeaders]="false"
      noDataText="No notifications to display"
      (onRowPrepared)="rowPrepared($event)"
      [elementAttr]="{ class: 'data-grid-row-clickable' }"
      (onRowClick)="markAsReadAndRedirect($event.data)"
      (onSelectionChanged)="onSelectedRowsChange()"
      (onOptionChanged)="onGridOptionChange($event)"
      test-id="notification-table">
      <dxo-data-grid-paging [pageSize]="pageSize()" />
      <dxo-data-grid-remote-operations
        [paging]="true"
        [sorting]="true" />
      <dxo-data-grid-selection
        mode="multiple"
        showCheckBoxesMode="always"
        selectAllMode="page" />
      <dxo-data-grid-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 50]"
        [showNavigationButtons]="true"
        [showInfo]="true" />
      <div
        class="tw:flex tw:items-center tw:gap-3"
        *dxTemplate="let data of 'nameTemplate'">
        <i
          class="pi tw:cursor-pointer"
          [ngClass]="
            data.data.isStarred
              ? 'pi-star-fill tw:text-yellow-600'
              : 'pi-star tw:hover:text-yellow-600'
          "
          test-id="notification-star"
          (click)="toggleStarred(data.data.id, data.data.isStarred, $event)"
          style="font-size: 14px"></i>

        <p-avatar
          [label]="getInitials(data.data.createdBy)"
          [style]="{ 'background-color': data.data.createdBy | uniqueRgbColor, color: 'white' }"
          styleClass="mr-2"
          shape="circle"
          [pTooltip]="data.data.createdBy" />
        <div class="tw:flex tw:flex-col">
          <div class="tw:flex tw:items-center tw:gap-2">
            <div
              [ngStyle]="{ 'font-weight': data.data.isViewed ? 'normal' : '600' }"
              test-id="notification-title">
              {{ data.data.renderedMessage.title }}
            </div>
            @if (isTypeofLineageLegendObject(data.data.messageData.targetType)) {
              <div
                class="notification-object-chip"
                [ngStyle]="getObjectTypeStyle(data.data.messageData.targetType)"
                test-id="notification-object-type">
                {{ data.data.messageData.targetType }}
              </div>
            }
            <i
              [class]="notificationIcons[data.data.type]"
              [pTooltip]="data.data.type"></i>
          </div>
          <div
            class="tw:text-sm tw:text-muted-color"
            test-id="notification-desc">
            {{ data.data.renderedMessage.message }}
          </div>
        </div>
      </div>
      <div
        class="tw:text-sm tw:flex tw:justify-end tw:ms-auto tw:pe-2 tw:gap-2 tw:items-center tw:text-muted-color"
        *dxTemplate="let data of 'timeTemplate'">
        <span
          [class.tw:hidden]="isMenuPopoverVisible()"
          [ngStyle]="{ 'font-weight': data.data.isViewed ? 'normal' : '600' }"
          test-id="notification-time">
          {{ data.data.createdDate | dateFromNow }}
        </span>
      </div>
    </dx-data-grid>
  </div>
</div>

<ng-template #eventFiltersMenu>
  <p-menu [model]="eventFilters()">
    <ng-template
      let-item
      pTemplate="item">
      <div
        test-id="notification-on-event-filter-change"
        class="tw:flex tw:items-center tw:gap-2 tw:p-1 tw:cursor-pointer"
        (click)="onEventFilterChange(!item.checked, item.value)">
        <p-checkbox
          test-id="notification-p-checkbox"
          [ngModel]="item.checked"
          [ngModelOptions]="{ standalone: true }"
          [binary]="true" />
        <label>
          {{ item.label }}
        </label>
      </div>
    </ng-template>
  </p-menu>
</ng-template>
